/* esm.sh - esbuild bundle(@lit/localize@0.12.2) esnext production */
var d="lit-localize-status";var R=(t,...e)=>({strTag:!0,strings:t,values:e}),X=R,I=t=>typeof t!="string"&&"strTag"in t,p=(t,e,o)=>{let s=t[0];for(let r=1;r<t.length;r++)s+=e[o?o[r-1]:r-1],s+=t[r];return s};var c=t=>I(t)?p(t.strings,t.values):t;var w=c,M=!1;function g(t){if(M)throw new Error("lit-localize can only be configured once");w=t,M=!0}var _=class{constructor(e){this.__litLocalizeEventHandler=o=>{o.detail.status==="ready"&&this.host.requestUpdate()},this.host=e}hostConnected(){window.addEventListener(d,this.__litLocalizeEventHandler)}hostDisconnected(){window.removeEventListener(d,this.__litLocalizeEventHandler)}},N=t=>t.addController(new _(t)),A=N;var $=()=>(t,e)=>(t.addInitializer(A),t);var u=class{constructor(){this.settled=!1,this.promise=new Promise((e,o)=>{this._resolve=e,this._reject=o})}resolve(e){this.settled=!0,this._resolve(e)}reject(e){this.settled=!0,this._reject(e)}};var i=[];for(let t=0;t<256;t++)i[t]=(t>>4&15).toString(16)+(t&15).toString(16);function C(t){let e=0,o=8997,s=0,r=33826,n=0,l=40164,v=0,f=52210;for(let L=0;L<t.length;L++)o^=t.charCodeAt(L),e=o*435,s=r*435,n=l*435,v=f*435,n+=o<<8,v+=r<<8,s+=e>>>16,o=e&65535,n+=s>>>16,r=s&65535,f=v+(n>>>16)&65535,l=n&65535;return i[f>>8]+i[f&255]+i[l>>8]+i[l&255]+i[r>>8]+i[r&255]+i[o>>8]+i[o&255]}var U="",W="h",q="s";function y(t,e){return(e?W:q)+C(typeof t=="string"?t:t.join(U))}var j=new WeakMap,z=new Map;function H(t,e,o){if(t){let s=o?.id??O(e),r=t[s];if(r){if(typeof r=="string")return r;if("strTag"in r)return p(r.strings,e.values,r.values);{let n=j.get(r);return n===void 0&&(n=r.values,j.set(r,n)),{...r,values:n.map(l=>e.values[l])}}}}return c(e)}function O(t){let e=typeof t=="string"?t:t.strings,o=z.get(e);return o===void 0&&(o=y(e,typeof t!="string"&&!("strTag"in t)),z.set(e,o)),o}function E(t){window.dispatchEvent(new CustomEvent(d,{detail:t}))}var h="",T,P,x,S,V,a=new u;a.resolve();var m=0,pt=t=>(g((e,o)=>H(V,e,o)),h=P=t.sourceLocale,x=new Set(t.targetLocales),x.add(t.sourceLocale),S=t.loadLocale,{getLocale:b,setLocale:D}),b=()=>h,D=t=>{if(t===(T??h))return a.promise;if(!x||!S)throw new Error("Internal error");if(!x.has(t))throw new Error("Invalid locale code");m++;let e=m;return T=t,a.settled&&(a=new u),E({status:"loading",loadingLocale:t}),(t===P?Promise.resolve({templates:void 0}):S(t)).then(s=>{m===e&&(h=t,T=void 0,V=s.templates,E({status:"ready",readyLocale:t}),a.resolve())},s=>{m===e&&(E({status:"error",errorLocale:t,errorMessage:s.toString()}),a.reject(s))}),a.promise};var xt=t=>{g(c);let e=t.sourceLocale;return{getLocale:()=>e}};export{d as LOCALE_STATUS_EVENT,pt as configureLocalization,xt as configureTransformLocalization,I as isStrTagged,p as joinStringsAndValues,$ as localized,w as msg,X as str,A as updateWhenLocaleChanges};
/*! Bundled license information:

@lit/localize/internal/locale-status-event.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/str-tag.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/types.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/default-msg.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/localized-controller.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/localized-decorator.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/deferred.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/fnv1a64.js:
  (**
   * @license
   * Copyright 2014 Travis Webb
   * SPDX-License-Identifier: MIT
   *)

@lit/localize/internal/id-generation.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/internal/runtime-msg.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/init/runtime.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/init/transform.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/localize/lit-localize.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=localize.mjs.map